var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcTrash = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 10L7 8",
    stroke: "inherit",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 10L9 8",
    stroke: "inherit",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2 5H14V5C12.8954 5 12 5.89543 12 7V9C12 10.8856 12 11.8284 11.4142 12.4142C10.8284 13 9.88562 13 8 13V13C6.11438 13 5.17157 13 4.58579 12.4142C4 11.8284 4 10.8856 4 9V7C4 5.89543 3.10457 5 2 5V5Z",
    stroke: "inherit",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03407 2.37059C7.09105 2.26427 7.21659 2.17033 7.39124 2.10332C7.56588 2.03632 7.77987 2 8 2C8.22013 2 8.43412 2.03632 8.60876 2.10332C8.78341 2.17033 8.90895 2.26427 8.96593 2.37059",
    stroke: "inherit",
    strokeLinecap: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcTrash);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ic-trash.dc80b783d011a45c8fb1c51a800f04e8.svg";